import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const locationOnHandWidget: DashboardWidgetConfiguration = {
  widgetId: "location.on-hand",
  name: "Stock on hand",
  description: "Stock on hand for the selected dashboard period.",
  apps: [
    "configuration",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "inventory.stock",
      ...period(1),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "on_hand_quantity",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Stock on hand",
    subtext: "",
    icon: "orders",
    color: "azure",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 0,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 1,
    defaultWidth: 3,
    defaultHeight: 1,
  },
};
